import React from "react";
import { Icon, Stack, Text } from "@bookingcom/bui-react";
import { CalendarCheckIcon, MoneyIncomingIcon } from "@bookingcom/bui-assets-react/streamline";
import useFareRulesInfoController from "./useFareRulesInfo.controller";
import { UIFlightData } from "@flights/types";

const useFareRulesInfo = (flight: UIFlightData) => {
  const { header, subheader, hasFareRules, changeable, cancellable } = useFareRulesInfoController(flight);

  if (!hasFareRules) return undefined;

  return {
    header,
    subheader,
    content: (
      <Stack gap={4}>
        {changeable ? (
          <Stack.Item>
            <Stack direction="row" gap={4}>
              <Stack.Item>
                <Icon size="large" svg={CalendarCheckIcon} />
              </Stack.Item>
              <Stack.Item grow alignSelf="center">
                <Text>{changeable.label}</Text>
              </Stack.Item>
            </Stack>
          </Stack.Item>
        ) : null}
        {cancellable ? (
          <Stack.Item>
            <Stack direction="row" gap={4}>
              <Stack.Item>
                <Icon size="large" svg={MoneyIncomingIcon} />
              </Stack.Item>
              <Stack.Item grow alignSelf="center">
                <Text>{cancellable.label}</Text>
              </Stack.Item>
            </Stack>
          </Stack.Item>
        ) : null}
      </Stack>
    )
  };
};

export default useFareRulesInfo;
